define('taoQtiItem/qtiXmlRenderer/renderers/interactions/TextEntryInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/element'], function(tpl){
    return {
        qtiClass : 'textEntryInteraction',
        template : tpl
    };
});
